import type { HTMLAttributes, SVGProps, ReactNode } from "react";
import { Children } from "react";
import { cn } from "@/lib/utils";

export type CursorProps = HTMLAttributes<HTMLDivElement>;

export const Cursor = ({ className, children, ...props }: CursorProps) => (
  <div className={cn("pointer-events-none relative select-none", className)} {...props}>
    {children}
  </div>
);

export type CursorPointerProps = SVGProps<SVGSVGElement>;

export const CursorPointer = ({ className, ...props }: CursorPointerProps) => (
  <svg
    aria-hidden
    className={cn("h-4 w-4 drop-shadow-sm", className)}
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M1 1L1 11.5L4 8.5L6 13L8.5 12L6.5 7.5L11 7.5L1 1Z" stroke="white" strokeWidth="1" strokeLinejoin="round" />
  </svg>
);

export type CursorBodyProps = HTMLAttributes<HTMLDivElement> & { children?: ReactNode };

export const CursorBody = ({ children, className, ...props }: CursorBodyProps) => {
  const count = Children.count(children);
  return (
    <div
      className={cn(
        "ml-3 -mt-1 inline-flex flex-col gap-0.5 rounded-md px-2 py-1 text-xs font-medium shadow-md",
        count > 1 && "rounded-tl-none [&>:first-child]:opacity-70",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
};

export type CursorNameProps = HTMLAttributes<HTMLSpanElement>;

export const CursorName = ({ className, ...props }: CursorNameProps) => (
  <span className={cn("text-[11px] leading-none", className)} {...props} />
);

export type CursorMessageProps = HTMLAttributes<HTMLSpanElement>;

export const CursorMessage = ({ className, ...props }: CursorMessageProps) => (
  <span className={cn("text-[11px] leading-none", className)} {...props} />
);